import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ComponentsService } from '../services/components.service';
import { VerifyEmailComponent } from '../components/verify-email/verify-email.component';

export const InterResponseHandlerInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);
  const components = inject(ComponentsService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Handle 401 Unauthorized
        authService.logout();
        router.navigate(['signin']);
      } else if (error.status === 400 && error.error.email_verification === false) {
        components.openModal(VerifyEmailComponent, 'verify your email', (data) => {
          if (!data.success) return;
        }, {}, .2)
       }

      // Optionally handle other errors here or pass them along
      return throwError(() => error);
    })
  );
};
